'use client';
import { useState } from 'react';
import * as ga from 'lib/ga';
import IconPinLocation from 'public/images/icon-pin-location.svg';
import IconMail from 'public/images/icon-mail.svg';
import IconPhone from 'public/images/icon-phone.svg';
import IconWebsite from 'public/images/icon-website.svg';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import SendEmailForm from '../../Modals/SendEmailForm';

export default function ProviderContactInfo({ provider }: { provider: any }) {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const { phone, email, website: websiteUrl, url, address, name } = provider;

  const website = websiteUrl ? websiteUrl : url;

  const webUrlClicked = () => {
    ga.event({
      action: 'search',
      params: {
        search_term: `Web URL clicked (${name})`
      }
    });
  };

  return (
    <>
      <section className={styles.wrapper}>
        <h3 className="capitalize">{t('contact_info')}</h3>
        <span className={styles.description}>{t('contact_partner')}</span>
        <ul>
          {phone ? (
            <li>
              <div className={`${styles.icon}`}>
                <IconPhone></IconPhone>
              </div>
              <div className={`${styles.phone} ${styles.info}`}>
                <h6>{t('phone')}</h6>
                <p>{phone}</p>
              </div>
            </li>
          ) : null}
          {url || website ? (
            <li>
              <div className={`${styles.icon}`}>
                <IconWebsite></IconWebsite>
              </div>
              <div className={styles.info}>
                <h6>{t('website')}</h6>
                <a
                  target="_blank"
                  href={/^http/i.test(website) ? website : `https://${website}`}
                  rel="noreferrer"
                  onClick={() => webUrlClicked()}
                  className={styles.link}
                >
                  {website}
                </a>
              </div>
            </li>
          ) : null}
          {address ? (
            <li>
              <div className={`${styles.icon}`}>
                <IconPinLocation />
              </div>
              <div className={styles.info}>
                <h6>{t('main_address')}</h6>
                <p>{address}</p>
              </div>
            </li>
          ) : null}
          {email ? (
            <li>
              <div className={`${styles.icon}`}>
                <IconMail />
              </div>
              <div className={styles.info}>
                <h6>{t('mail')}</h6>
                <a className={styles.link} onClick={() => setOpen(true)}>
                  {email}
                </a>
              </div>
            </li>
          ) : null}
        </ul>
      </section>
      {open ? (
        <SendEmailForm
          open={open}
          setOpen={setOpen}
          partnerEmail={email}
          partnerName={name}
          partnerInfo
        />
      ) : null}
    </>
  );
}
